import React, { useState } from 'react'
import { Button, message, Modal, Upload } from 'antd'
import { SendOutlined, SyncOutlined } from '@ant-design/icons'
import { blue } from '../../../color'
import { observer } from 'mobx-react'
import uploadISOFileStore from './uploadISOFileStore'
import DraggerUploadButton from '../../../components/Common/DraggerUploadButton'

const UploadIsoFileModal = props => {
  const { visible, parentFolderId, onClose } = props
  const { isLoading } = uploadISOFileStore
  const [fileList, setFileList] = useState([])

  const handleImportFile = async () => {
    if (fileList.length === 0) {
      return message.warning('Hãy chọn file!')
    }

    try {
      const formData = new FormData()
      formData.append('file', fileList[0])
      formData.append('folderId', parentFolderId)
      await uploadISOFileStore.upload(formData)

      closeAndResetForm()

      message.success('Tải file thành công')
    } catch (err) {
      console.log(err)
      if (err && err.errorCode && err.errorCode == 'FILE_NAME_DUPLICATE') {
        message.error('Tên file đã tồn tại')
      } else {
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      }
    } finally {
      uploadISOFileStore.isLoading = false
    }
  }

  const handleChangeFile = info => {
    console.log('handleChangeFile', info)
    setFileList([info.file])
  }

  const closeAndResetForm = () => {
    setFileList([])
    onClose()
  }

  return (
    <Modal
      width={650}
      title="Tải file lên thư mục"
      wrapClassName="custom-modal-wrapper"
      footer={null}
      closable={true}
      visible={visible}
      onCancel={() => {
        closeAndResetForm()
      }}>
      <Upload.Dragger
        valuePropName={'fileList'}
        fileList={fileList}
        onChange={handleChangeFile}
        beforeUpload={() => false}
        showUploadList={true}
        className="custom-dragger-upload">
        <DraggerUploadButton />
      </Upload.Dragger>

      {/* <Button
        style={{ marginTop: 16, width: '100%' }}
        icon={<SendOutlined />}
        loading={isLoading}
        onClick={handleImportFile}
        type={'primary'}>
        Tải lên
      </Button> */}

      <div className="custom-modal-footer">
        <Button
          type="default"
          onClick={() => {
            closeAndResetForm()
          }}
          htmlType="reset"
          className="custom-ant-button w-160">
          Hủy bỏ
        </Button>
        <Button
          loading={isLoading}
          htmlType={'submit'}
          type={'primary'}
          onClick={handleImportFile}
          className="custom-ant-button w-160">
          Tải lên
        </Button>
      </div>
    </Modal>
  )
}

export default observer(UploadIsoFileModal)
